import { Wrench, Clock } from "lucide-react";

export default function UnderDevelopment({ featureName = "Cette fonctionnalité" }) {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200 min-h-64">
      <div className="flex items-center mb-4">
        <div className="relative">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
            <Wrench className="w-8 h-8 text-amber-600" />
          </div>
          <div className="absolute -top-1 -right-1">
            <Clock className="w-5 h-5 text-blue-500 animate-pulse" />
          </div>
        </div>
      </div>

      <h2 className="text-xl font-semibold text-gray-800 mb-2 text-center">
        {featureName}
      </h2>

      <p className="text-gray-600 text-center mb-4 max-w-sm">
        Cette fonctionnalité est en cours de refactorisation et sera bientôt disponible.
      </p>

      <div className="flex items-center space-x-1">
        <div className="w-2 h-2 bg-amber-500 rounded-full animate-bounce"></div>
        <div className="w-2 h-2 bg-amber-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
        <div className="w-2 h-2 bg-amber-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
      </div>
    </div>
  );
}
